import { getMessages } from '../../../../../../../store/constants';

export const NOTIFY_USERS_SHOW = getMessages().getText('notify.users.show');
export const NOTIFY_USERS_COLLAPSE = getMessages().getText('notify.users.collapse');
export const NOTIFY_USERS_REMOVE = getMessages().getText('common.remove');
export const NOTIFY_USERS_SHORT_MAX = 5;
export const NOTIFY_USERS_MOBILE = 380; // опытным путём выяснилось, что если меньше 380px, то не помещается 6 квадратов
export const NOTIFY_USERS_SHORT_MAX_MOBILE = 4;
